import { KompasCGFDoorsConfigs } from "./kompas/mounts-cgf-door.config";
import { KompasNoDoorsConfigs } from "./kompas/mounts-no-door.config";
import { KompasSlidingDoorsConfigs } from "./kompas/mounts-sliding-door.config";
import { KompasSwingDoorsConfigs } from "./kompas/mounts-swing-door.config";

export const KompasCustomXLinesConfigs = {
    noDoors: KompasNoDoorsConfigs,
    slidingDoors: KompasSlidingDoorsConfigs,
    swingDoors: KompasSwingDoorsConfigs,
    cgfDoors: KompasCGFDoorsConfigs,
};
